import axios from "axios";

import { apiDomain } from "../../store/constants";

const USPExtend = {
  index(params) {
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "GET",
      params: params,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  show(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  create(form_c_id) {
    return axios({
      url: apiDomain + `api/pending-form/create?form_c_id=${form_c_id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  store(data) {
    // data.files = JSON.stringify(data.files);
    return axios({
      url: apiDomain + `api/pending-form`,
      method: "POST",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  edit(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}/edit`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  update(payload) {
    return axios({
      url: apiDomain + `api/pending-form/${payload.id}`,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  delete(id) {
    return axios({
      url: apiDomain + `api/pending-form/${id}`,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default USPExtend;
